var Component = require("!../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../vue-loader/lib/selector?type=script&index=0!./sv-panel.vue"),
  /* template */
  require("!!../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-65c5c78e\"}!../../../../../vue-loader/lib/selector?type=template&index=0!./sv-panel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/qfpay-element-ui/packages/color-picker/src/components/sv-panel.vue
// module id = 784
// module chunks = 1